import { TextField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { DataFieldIndexResource } from "../../../shared/types/dataField";
import { UserTenantMultiSelect } from "../../../shared/ui/UserTenantSelect";
import { LanguageSingleSelectField } from "../shared/select/LanguageSingleSelectField";
import { ContactAttribute } from "../shared/types/contactAttribute";
import { ContactDataFieldField } from "./ContactDataFieldField";

export const ContactAttributeField: FC<{
	attribute: ContactAttribute;
	dataFields: DataFieldIndexResource[];
	name: string;
}> = ({ attribute, dataFields, name }) => {
	const { t } = useTranslation();

	switch (attribute.type) {
		case "column": {
			switch (attribute.entityType) {
				case "firstName":
					return <TextField key={attribute.id} name={name} label={t("First name")} />;
				case "lastName":
					return <TextField key={attribute.id} name={name} label={t("Last name")} />;
				case "locale":
					return <LanguageSingleSelectField key={attribute.id} name={name} label={t("Locale")} />;
				default:
					return null;
			}
		}
		case "relation": {
			switch (attribute.entityType) {
				case "tenants":
					return <UserTenantMultiSelect key={attribute.id} name={name} label={t("Tenants")} />;
				default:
					return null;
			}
		}
		case "dataField": {
			const dataField = dataFields.find((dataField) => dataField.id === attribute.entityType);

			if (!dataField) {
				throw new Error("Unknown datafield");
			}

			return <ContactDataFieldField dataField={dataField} name={name} />;
		}
	}
};
